<!-- 解决方案列表 -->
<template>
    <div class="solution-list-container">
    </div>
</template>

<script>
import { recordUserTrack } from '@/libs/common'
import { getDetailsInfo } from '@/api/channel'
export default {
    data () {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            showNav: true,
            id: '',
            title: '',
            solutionList: [],
            pageSize: 1,
            last_page: ''
        }
    },
    components: {},
    computed: {
        whetherSignature () {
            return this.$store.state.user.whetherSignature
        }
    },
    watch: {
        whetherSignature (newVAl) {
            if (newVAl === true) {
                this.sharePage()
            }
        }
    },
    activated () {
        this.showNav = true
        this.sharePage()
    },
    deactivated () {
        this.showNav = false
    },
    created () { },
    mounted () {
        this.getDetailsInfo()
    },
    methods: {
        getDetailsInfo () {
            getDetailsInfo({ id: this.$route.query.id }).then(res => {
                if (res.errCode === 0) {
                    // this.recordTrack()
                    window.location.href = `${res.data.url}`
                }
            })
        },
        recordTrack () {
            var params = {
                model: 'track',
                model_id: this.$route.query.id,
                user_id: this.$store.state.user.id,
                title: '渠道跟踪',
                action: 'view'
            }
            recordUserTrack(params) // 记录用户轨迹
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
